import React from 'react';

import styles from 'pages/Dashboard/steps/AcceptOffer/common/OffersTableWrapper/OfferRowLabel/OfferRowLabel.module.scss';
import { OfferDto } from 'api/OffersApi';

export interface TableRowLabelProps {
  offer: OfferDto;
}

const OfferRowLabel = ({ offer }: TableRowLabelProps) => {
  let text = null;

  if (offer.isLowestPayment) {
    text = 'Lowest Payment';
  } else if (offer.isLowestRate) {
    text = 'Lowest Rate';
  }

  if (text) {
    return (
      <div className={styles.tableRowLabel}>
        <div className={styles.tableRowLabelLeftElement}></div>
        <div className={styles.tableRowLabelRightElement}></div>
        {text}
      </div>
    );
  }

  return null;
};

export default OfferRowLabel;
